import type { AccountNumber, CrossBorderReceiver, Receiver } from '../../generated-types';

export enum ReceiverType {
    RECEIVER = 'RECEIVER',
    CROSS_BORDER_RECEIVER = 'CROSS_BORDER_RECEIVER',
}

export interface ReceiverElement {
    id: string;
    accountNumber: AccountNumber;
    name: string;
    receiverType: ReceiverType;
    receiver?: Receiver;
    crossBorderReceiver?: CrossBorderReceiver;
}
